module.exports = __webpack_public_path__ + "img/about-1-1.2acaa78c.jpeg";